<template>
  <div class="container-fluid">
    <div class="block-header">
      <div class="row clearfix breadcrumb-margin-lg">
        <div class="col-md-6 col-sm-12">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="#">Master</a></li>
              <li class="breadcrumb-item"><a href="#">Helper Master</a></li>
              <li class="breadcrumb-item active" aria-current="page">Add Helper Master</li>
            </ol>
          </nav>
        </div>
        <div class="col-md-6 col-sm-12 text-right">
          <router-link
            :to="'/admin/master/helper_master'"
            class="btn btn-outline-danger"
            title="Go to HelperMaster"
            ><i class="fa fa-arrow-circle-left mr-2"></i>Back</router-link
          >
        </div>
      </div>
    </div>
    <div class="row clearfix">
      <div class="col-md-6 mx-auto">
        <div class="card">
          <div class="card-header bg-primary custom-title theme-backcolor">
            <h6 class="text-white fs">Add New Helper Master</h6>
          </div>
          <v-app class="fixVapp">
            <div class="body">
              <form>
                <div class="form-group">
                  <label class="text-muted">Select HelperType</label>
                  <v-autocomplete
                    attach
                    :rules="nameRules"
                    v-model="selected"
                    label=""
                    class="mt-n8"
                    :items="HelperTypes"
                    item-text="helpertype_title"
                    item-value="helpertype_id"
                    outlined
                    dense
                    :error-messages="errors.helpertype_id"
                  ></v-autocomplete>
                </div>

                <div class="form-group mt-n4">
                  <label class="text-muted">Helper Master Title</label>
                  <v-text-field
                    type="text"
                    class="mt-n8"
                    name="helper_master_title"
                    v-model="helper_master_title"
                    label=""
                    :rules="nameRules"
                    outlined
                    dense
                    autocomplete="off"
                    :error-messages="errors.helper_master_title"
                  />
                </div>
                <div class="d-flex justify-content-center mt-0">
                  <button
                    type="button"
                    class="btn btn-primary text-white theme-backcolor"
                    @click="AddHelperMaster"
                  >
                    <i class="fa fa-save mr-2"></i>Save
                  </button>
                  <v-overlay :value="overlay">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                  </v-overlay>
                </div>
              </form>
            </div>
          </v-app>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataService from '../../../dataservice';
export default {
  components: {},
  data() {
    return {
      errors: '',
      HelperTypes: [],
      //Domain Id Shoud be dynamic based on drop down
      selected: null,
      helper_master_title: '',
      helper_master_isactive: 'Y',
      overlay: false,
    };
  },
  created() {
    DataService.getActiveHelperType()
      .then(response => {
        this.HelperTypes = response.data;
      })
      .catch(error => {
        // console.log(error);
      });
  },
  watch: {
    overlay(val) {
      val &&
        setTimeout(() => {
          this.overlay = false;
        }, 3000);
    },
  },
  methods: {
    AddHelperMaster() {
      this.overlay = true;
      const data = new FormData();
      data.append('helper_master_title', this.helper_master_title);
      data.append('helpertype_id', this.selected);
      data.append('helper_master_isactive', this.helper_master_isactive);
      DataService.createHelperMaster(data)
        .then(response => {
          this.s('Helper Master', 'Record Added Successfully!');
          this.$router.push({ path: '/admin/master/helper_master' });
        })
        .catch(error => {
          this.errors = error.response.data.error;
          this.overlay = false;
          this.e("Oop's", 'Something went wrong.');
        });
    },
  },
};
</script>
<style scoped>
.fixVapp {
  height: 10px;
}
.custom-title {
  padding: 8px 20px !important;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.fs {
  font-size: 18px !important;
  font-weight: 600 !important;
}
</style>
